export const themeGeorgia = {
    primarycolor: "#153866",
    secondarycolor : "#c81c50",
    tertiarycolor: "#c81c50",
    boxcolor : "white",
    subboxcolor :  "rgba(247, 254, 255, 0.1)",
    highlightcolor: "#565252",
    primarybuttonfontcolor: "white",
    black : "black",
    white: "white",
    dangercolor: "red",
    successcolor : "green",
    whiteblue: "#153866",
    lightbeige : "rgba(253, 202, 104, 0.2)",
    navcolor: "white",
    transparentcolor : "rgba(190,0,64 ,0.50)",
    grey : "#D9D9D9",
}

export const themeOther = {
    primarycolor: "#56a5ae",
    secondarycolor : "#f8b74d",
    tertiarycolor: "#0b2026",
    boxcolor : "white",
    subboxcolor :  "rgba(247, 254, 255, 0.1)",
    highlightcolor: "#565252",
    primarybuttonfontcolor: "white",
    black : "black",
    white: "white",
    dangercolor: "red",
    successcolor : "green",
    whiteblue: "#153866",
    lightbeige : "rgba(253, 202, 104, 0.2)",
    navcolor: "white",
    transparentcolor : "rgba(190,0,64 ,0.50)",
    grey : "#D9D9D9" 
  };